import { type Reducer } from '@reduxjs/toolkit'
import { produce } from 'immer'
import uniqBy from 'lodash/uniqBy'
import { type ActionType, getType } from 'typesafe-actions'
import { type FacebookAccount } from '@/connect-types/reviews/facebookAccounts.type'
import { type FacebookPage } from '@/connect-types/reviews/facebookPages.type'
import message from '@/common/message/message'
import * as actions from './settings.actions'

export type SettingsAction = ActionType<typeof actions>

export interface StateType {
  isLoading: boolean

  facebookAccounts: FacebookAccount[]
  facebookAuthorizationUrl: string | null | undefined
  facebookPages: FacebookPage[]
}

const initialState: StateType = {
  isLoading: false,
  facebookAccounts: [],
  facebookAuthorizationUrl: null,
  facebookPages: [],
}

const settingsReducer: Reducer<StateType, SettingsAction> = (
  state = initialState,
  action
) =>
  produce<StateType>(state, (draft: any) => {
    switch (action.type) {
      case getType(actions.locationsFacebookAccountsRequest): {
        draft.isLoading = true
        draft.facebookAccounts = []
        break
      }

      case getType(actions.locationsFacebookAccountsRequestSuccess): {
        draft.isLoading = false

        draft.facebookAccounts = uniqBy(
          action.payload.facebookAccounts,
          'accessToken'
        ).map((item: any) => item)
        break
      }

      case getType(actions.locationsFacebookAccountsRequestFailure): {
        draft.isLoading = false
        break
      }

      case getType(actions.locationsFacebookAccountsPagesRequest): {
        draft.isLoading = true
        draft.facebookPages = []
        break
      }

      case getType(actions.locationsFacebookAccountsPagesRequestSuccess): {
        draft.isLoading = false
        draft.facebookPages = action.payload.facebookPages
        break
      }

      case getType(actions.locationsFacebookAccountsPagesRequestFailure): {
        draft.isLoading = false
        break
      }

      case getType(actions.locationsFacebookAuthorizeAccountRequest): {
        draft.isLoading = true
        draft.facebookAuthorizationUrl = null
        break
      }

      case getType(actions.locationsFacebookAuthorizeAccountRequestSuccess): {
        draft.isLoading = false
        draft.facebookAuthorizationUrl = action.payload.redirectUrl
        break
      }

      case getType(actions.locationsFacebookAuthorizeAccountRequestFailure): {
        draft.isLoading = false
        break
      }

      case getType(actions.updateLocationsFacebookPageRequest): {
        draft.isLoading = true

        break
      }

      case getType(actions.updateLocationsFacebookPageRequestSuccess): {
        draft.isLoading = false

        message.success('Facebook settings updated')
        break
      }

      case getType(actions.updateLocationsFacebookPageRequestFailure): {
        draft.isLoading = false

        break
      }
    }
  })

export default settingsReducer
